import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportSelfOrganization_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportSelfOrganization extends Report<ReportSelfOrganization_Settings> {

    static reportName   : string = "Self organization"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_SELF_ORGANIZATION
        super(data);

        this.icon        = "isvg-self-org"
        this.description = "Provides insights into personal work habits and self-organization patterns."

        this.settings    = new ReportSelfOrganization_Settings(data.settings)
    }

    static initFromSavedView(savedView:SavedView): ReportSelfOrganization {
        return new ReportSelfOrganization(savedView.toReportConfig())
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportSelfOrganization_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

}
